import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { PillButton, PillInput } from '@/components/FormField';

export function ForgotPasswordPage() {
  const sendReset = useAuthStore((s) => s.sendReset);
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await sendReset(email);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Une erreur est survenue');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-dvh bg-brand-darkest text-white flex flex-col items-center justify-center px-6">
      <h1 className="text-2xl font-semibold mb-6">
        Réinitialisation du mot de passe
      </h1>
      {done ? (
        <div className="w-full max-w-sm flex flex-col gap-4 text-center">
          <p className="text-white/80">
            Un courriel de réinitialisation vous a été envoyé.
          </p>
          <Link to="/login" className="underline text-sm">
            Retour à la connexion
          </Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="w-full max-w-sm flex flex-col gap-4">
          <PillInput
            type="email"
            required
            autoComplete="email"
            placeholder="Courriel"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && (
            <p className="text-sm text-red-300 text-center">{error}</p>
          )}
          <PillButton type="submit" disabled={submitting}>
            {submitting ? 'Envoi…' : 'Envoyer le courriel'}
          </PillButton>
          <Link to="/login" className="underline text-sm text-center">
            Retour à la connexion
          </Link>
        </form>
      )}
    </div>
  );
}
